import React from 'react';
import { content } from '../data/content';
import { motion } from 'framer-motion';
import Button from '../components/Button';
import { Box, Building2, ArrowUpRight, LucideBuilding } from 'lucide-react';

const icons = [Building2, Box, LucideBuilding];

const WhatMakesUsDifferent = () => {
  return (
    <section className="py-24 bg-navy text-white relative overflow-hidden">
      {/* Subtle Wavy Background (CSS Mesh) */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <svg viewBox="0 0 1000 1000" className="w-full h-full text-white/5" preserveAspectRatio="none">
          <path d="M0,1000 C300,800 400,1200 700,1000 C1000,800 1200,1200 1300,1000" fill="none" stroke="currentColor" strokeWidth="2" />
          <path d="M0,900 C200,700 300,1100 600,900 C900,700 1100,1100 1300,900" fill="none" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </div>

      <div className="container-custom relative z-10">
        {/* Header Row */}
        <div className="flex flex-col md:flex-row justify-between items-start mb-12 gap-8">
          <div>
            <h2 className="text-4xl lg:text-5xl font-display font-medium mb-6 tracking-tight">
              {content.differentSection.title}
            </h2>
            <div className="h-1 w-32 bg-white rounded-full mb-12" />
          </div>
          {/* <Button className="bg-[#4DB8E6] text-white hover:bg-[#4DB8E6]/90 px-8 py-3 rounded-lg text-sm font-bold tracking-widest flex items-center gap-2 shadow-lg shadow-[#4DB8E6]/20">
            CONTACT <ArrowUpRight size={18} />
          </Button> */}
        </div>

        {/* Text Description Row */}
        <div className="max-w-4xl mb-20">
          <p className="text-3xl lg:text-4xl font-medium leading-tight mb-6">
            {content.differentSection.description}
          </p>
          <p className="text-white/40 text-sm md:text-base leading-relaxed max-w-2xl font-medium uppercase tracking-wider">
            {content.differentSection.subDescription}
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-24">
          {content.differentSection.blocks.map((block, idx) => {
            const Icon = icons[idx] || Box;
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 }}
                viewport={{ once: true }}
                className="bg-[#1a365d]/50 border border-white/5 p-12 rounded-[2rem] text-center hover:bg-[#1a365d]/70 transition-all group"
              >
                <div className="w-16 h-16 mx-auto bg-transparent border-2 border-white/10 rounded-2xl flex items-center justify-center text-white mb-8 group-hover:scale-110 transition-transform">
                  <Icon size={32} strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-bold mb-4">{block.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed font-medium">
                  {block.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>

      {/* Large Feature Image - Full Width Style */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="relative w-full h-[600px] overflow-hidden"
      >
        <img
          src="/office-team.jpg"
          alt="Keel Info Solutions Team"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-navy/10" />
      </motion.div>
    </section>
  );
};

export default WhatMakesUsDifferent;
